function hasStrictSuccessEnvelope(payload) {
  return (
    payload &&
    typeof payload === 'object' &&
    !Array.isArray(payload) &&
    payload.success === true &&
    Object.prototype.hasOwnProperty.call(payload, 'data')
  )
}

function unwrapStrictPayload(payload) {
  if (!hasStrictSuccessEnvelope(payload)) {
    throw new Error('Expected strict success response envelope')
  }

  return payload.data
}

function unwrapListPayload(payload) {
  const data = unwrapStrictPayload(payload)

  if (!data || typeof data !== 'object' || !Array.isArray(data.items)) {
    throw new Error('Expected strict list response with data.items')
  }

  return data.items
}

function requireStrictResponseEnvelope(payload) {
  if (!hasStrictSuccessEnvelope(payload)) {
    throw new Error('Expected strict success response envelope')
  }

  return payload
}

export { requireStrictResponseEnvelope, unwrapListPayload, unwrapStrictPayload }
